import { PropsWithChildren } from 'react';

import { useTranslate } from '@i18n';
import { Box, Inline, MinusIcon, PlusIcon, Stack, Text, u } from '@ui';

import * as css from './AxisMeaning.css';

type AxisMeaningProps = {
    positiveMeaningI18nKey: string | null;
    negativeMeaningI18nKey: string | null;
};

export const AxisMeaning = ({ positiveMeaningI18nKey, negativeMeaningI18nKey }: AxisMeaningProps) => {
    if (!positiveMeaningI18nKey && !negativeMeaningI18nKey) {
        return;
    }
    return (
        <Inline flexWrap="wrap" gap={u(4)} pb={u(2)}>
            {negativeMeaningI18nKey && (
                <MeaningContent meaningI18nKey={negativeMeaningI18nKey} labelI18nKey="swing_guide.minus_value">
                    <MinusIcon size={22} weight="bold" />
                </MeaningContent>
            )}
            {positiveMeaningI18nKey && (
                <MeaningContent meaningI18nKey={positiveMeaningI18nKey} labelI18nKey="swing_guide.plus_value">
                    <PlusIcon size={22} weight="bold" />
                </MeaningContent>
            )}
        </Inline>
    );
};

const MeaningContent = ({
    meaningI18nKey,
    labelI18nKey,
    children,
}: PropsWithChildren<{ meaningI18nKey: string; labelI18nKey: string }>) => {
    const t = useTranslate();
    return (
        <Inline className={css.meaning} alignItems="center" gap={u(2)}>
            <Box flexShrink={0} p={u(1)} justifyContent="center" alignItems="center" className={css.meaningIcon}>
                {children}
            </Box>
            <Stack gap={u(0.5)}>
                <Text variant="p">{t(labelI18nKey)}</Text>
                <Text variant="p" weight={700}>
                    {t(meaningI18nKey)}
                </Text>
            </Stack>
        </Inline>
    );
};
